import { AssistantToolDefinition } from '@paragon/contract-library';

import { contextTools, navigationTools } from './contextTools';
import { diagnosisTools } from './diagnosisTools';
import { docsTools } from './docsTools';
import { engineeringTools } from './engineeringTools';
import { layoutStructureTools } from './layoutStructureTools';
import { layoutTools } from './layoutTools';
import { loadTools } from './loadTools';
import { memberCutTools } from './memberCutTools';
import { outputTools } from './outputTools';
import { plateTools } from './plateTools';
import { pointingTools } from './pointingTools';
import { projectTools } from './projectTools';
import { settingsTools } from './settingsTools';
import { trussGeometryTools } from './trussGeometryTools';
import { trussManagementTools } from './trussManagementTools';
import { trussSetupTools } from './trussSetupTools';
import { trussTools } from './trussTools';
import { AnyAssistantTool } from './types';

export const ASSISTANT_TOOLS: readonly AnyAssistantTool[] = [
  ...contextTools,
  ...pointingTools,
  ...navigationTools,
  ...layoutTools,
  ...layoutStructureTools,
  ...trussTools,
  ...memberCutTools,
  ...trussManagementTools,
  ...trussSetupTools,
  ...trussGeometryTools,
  ...plateTools,
  ...loadTools,
  ...engineeringTools,
  ...diagnosisTools,
  ...settingsTools,
  ...outputTools,
  ...projectTools,
  ...docsTools,
];

export function findAssistantTool(name: string) {
  return ASSISTANT_TOOLS.find((tool) => tool.name === name) ?? null;
}

export function getToolDefinitions(tools: readonly AnyAssistantTool[] = ASSISTANT_TOOLS): AssistantToolDefinition[] {
  return tools.map(({ name, description, inputSchema }) => ({ name, description, inputSchema }));
}
